import React, { useState } from "react";
import InlineSVG from "react-inlinesvg";
import Modal from "react-modal";
import styled from "styled-components/macro";
import { useSudowriteStore } from "../../../stores/sudowriteStore";
import AutoPlaySilentVideo from "../../AutoPlaySilentVideo";

const modalOuterStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    zIndex: "30000",
    width: "80vw",
    height: "80vh",
    maxWidth: "600px",
    maxHeight: "660px",
    transform: "translate(-50%, -50%)",
    border: "none",
    borderRadius: "20px",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.10), 0px 0px 2px 0px rgba(0, 0, 0, 0.25)",
    padding: "29px 27px",
    overflow: "hidden",
  },
  overlay: {
    backgroundColor: "rgba(55, 55, 55, 0.7)",
  },
};

const ModalInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  justify-content: space-between;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--grey-2);
    border-radius: 5px;
  }

  .header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;

    .header__title,
    .close {
      flex-basis: 50%;
    }

    .header__title {
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      text-align: left;
    }
    .close {
      text-align: right;
      cursor: pointer;

      svg {
        g {
          opacity: 1;
        }
        path {
          fill: var(--grey-0);
        }
      }
    }
  }

  .content {
    margin-top: 27px;

    &.compact {
      margin-top: 0;
    }

    a {
      color: #383838;
      text-decoration: underline;
    }

    .banner-image {
      video {
        width: auto;
        max-height: 328px;
        border-radius: 10px;
        border: 1px solid #d9d9d9;
        margin: 0 auto;
      }
      img {
        width: 100%;
        box-sizing: border-box;
      }
    }

    .content__title {
      color: #383838;
      text-align: center;
      font-family: GT Super Text;
      font-size: 25px;
      font-style: normal;
      font-weight: 400;
      line-height: 110.7%;
      margin-top: 42px;

      &.compact {
        margin-top: 0;
      }
    }

    .content__body {
      color: #000;
      text-align: center;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%; /* 22.4px */
      opacity: 0.5;
      margin-top: 16px;
      max-width: 575px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .footer {
    margin-top: 10px;
    a.button {
      display: inline-block;
      font-size: 16px;
      background: var(--primary-cta);
      color: white;
      border: 0;
      border-radius: 8px;
      font-family: Inter;
      font-weight: 500;
      padding: 15px 40px;
      cursor: pointer;
      margin-top: 15px;
      text-decoration: none;
      text-align: center;

      &.secondary {
        background: var(--grey-3);
        color: var(--grey-2);
      }
    }

    &.half {
      display: flex;
      gap: 10px;
      width: 100%;

      a {
        flex-basis: 50%;
      }
    }
  }
`;

const StepIndicator = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  margin-top: 20px;

  .step {
    width: 60px;
    height: 5px;
    border-radius: 2px;
    background-color: var(--grey-3);
    margin: 0 5px;

    &.active {
      background-color: #4808d1;
    }
  }
`;

function BaseModal({ children }) {
  return (
    <Modal
      isOpen={true}
      style={modalOuterStyles}
    >
      {children}
    </Modal>
  );
}

export function V4TransitionModalGeneral({ subscription, userData }) {
  return (
    <BaseModal>
      <ModalInnerContainer>
        <div className="header">
          <div className="header__title">What's new</div>
          <div
            className="close [&_svg_path]:fill-[#383838]"
            onClick={() => userData?.update({ "v4transition.hasSeenGeneralModal": true })}
          >
            <InlineSVG src="/assets/close.svg" />
          </div>
        </div>
        <div className="content">
          <div className="banner-image">
            <img
              src="/assets/pricing/wordsToCredits.png"
              alt=""
            />
          </div>
          <div className="content__title">More Bang for your Buck with Credits</div>
          <p className="content__body">
            Sudowrite is updating our plans to make them a better value. Your price isn’t changing, but you’ll soon receive credits monthly instead of AI words.{" "}
            {subscription?.currentPlan().interval === "month"
              ? `Your plan will switch to credits on
            your next billing cycle.`
              : `Your plan will switch to credits within the week.`}{" "}
            When it does, it will unlock several new features.
          </p>
        </div>
        <div className="footer">
          <a
            href={`https://docs.sudowrite.com/plans--account/wBnmhtSyMcWtk2BLzifGkz/what-are-credits/qzSpgs9UDPEtwYcdczkLd3`}
            className="button footer__button"
            target="_blank"
          >
            Read all the Details
          </a>
        </div>
      </ModalInnerContainer>
    </BaseModal>
  );
}

export function V4TransitionModalActivated({ subscription, userData }) {
  const [step, setStep] = useState(0);

  const closeModal = () => {
    userData?.update({ "v4transition.hasSeenActivatedModal": true });
  };
  let steps = [];
  steps = [
    <ModalInnerContainer>
      <div className="header">
        <div className="header__title">What's new</div>
        <div
          className="close"
          onClick={closeModal}
        >
          <InlineSVG src="/assets/close.svg" />
        </div>
      </div>
      <div className="content compact">
        <div className="banner-image">
          <AutoPlaySilentVideo
            key={step}
            webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/pricing/new-plans-animation.webm"
            mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/pricing/new-plans-animation.mp4"
            immediate={true}
          />
        </div>
        <StepIndicator>
          {Array(3)
            .fill()
            .map((_, i) => (
              <div
                className={`step ${i === step ? "active" : ""}`}
                key={i}
              />
            ))}
        </StepIndicator>
        <div className="content__title compact">Your plan was updated</div>
        <p className="content__body">
          You’ll now receive credits each month (instead of AI words) to use on Sudowrite’s AI features. We sent you an email with details regarding your specific plan, and included details on any
          word -&gt; credit conversions.
        </p>
      </div>
      <div className="footer half">
        <a
          href="#"
          className="button footer__button secondary"
          onClick={(e) => {
            e.preventDefault();
            previous();
          }}
        >
          Back
        </a>
        <a
          href="#"
          className="button footer__button"
          onClick={(e) => {
            e.preventDefault();
            next();
          }}
        >
          Next
        </a>
      </div>
    </ModalInnerContainer>,
    <ModalInnerContainer>
      <div className="header">
        <div className="header__title">What's new</div>
        <div
          className="close"
          onClick={() => userData?.update({ "v4transition.hasSeenActivatedModal": true })}
        >
          <InlineSVG src="/assets/close.svg" />
        </div>
      </div>
      <div className="content compact">
        <div className="banner-image">
          <AutoPlaySilentVideo
            key={step}
            webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/pricing/New%20Features.webm"
            mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/pricing/New%20Features.mp4"
            immediate={true}
          />
        </div>
        <StepIndicator>
          {Array(3)
            .fill()
            .map((_, i) => (
              <div
                className={`step ${i === step ? "active" : ""}`}
                key={i}
              />
            ))}
        </StepIndicator>
        <div className="content__title compact">How many credits do things cost?</div>
        <p className="content__body">
          Use Recent Activity to see how many credits you’ve used. Different features cost different amounts (
          <a
            href={`https://docs.sudowrite.com/plans--account/wBnmhtSyMcWtk2BLzifGkz/what-are-credits/qzSpgs9UDPEtwYcdczkLd3`}
            target="_blank"
          >
            more details
          </a>
          ), but overall you’ll likely get more use out of Sudowrite than you did before, at the same price.
        </p>
      </div>
      <div className="footer half">
        <a
          href="#"
          className="button footer__button secondary"
          onClick={(e) => {
            e.preventDefault();
            previous();
          }}
        >
          Back
        </a>
        <a
          href="#"
          className="button footer__button"
          onClick={(e) => {
            e.preventDefault();
            next();
          }}
        >
          Next
        </a>
      </div>
    </ModalInnerContainer>,
    <ModalInnerContainer>
      <div className="header">
        <div className="header__title">What's new</div>
        <div
          className="close"
          onClick={() => userData?.update({ "v4transition.hasSeenActivatedModal": true })}
        >
          <InlineSVG src="/assets/close.svg" />
        </div>
      </div>
      <div className="content compact">
        <div className="banner-image">
          <AutoPlaySilentVideo
            key={step}
            webmURL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/pricing/Recent%20Activity.webm"
            mp4URL="https://d1ogpp28d9d3d3.cloudfront.net/sudowrite/pricing/Recent%20Activity.mp4"
            immediate={true}
          />
        </div>
        <StepIndicator>
          {Array(3)
            .fill()
            .map((_, i) => (
              <div
                className={`step ${i === step ? "active" : ""}`}
                key={i}
              />
            ))}
        </StepIndicator>
        <div className="content__title compact">Credits unlock new features</div>
        <p className="content__body">
          With credits, you gain access to 4 brand new AI models, the ability to share 3x more of your story for Feedback, and faster-working features. Plugins, Story Bible improvements, and lots more
          to come too.
          <br />
          <a
            href={`https://docs.sudowrite.com/plans--account/wBnmhtSyMcWtk2BLzifGkz/what-are-credits/qzSpgs9UDPEtwYcdczkLd3`}
            target="_blank"
          >
            Learn more
          </a>
        </p>
      </div>
      <div className="footer half">
        <a
          href="#"
          className="button footer__button secondary"
          onClick={(e) => {
            e.preventDefault();
            previous();
          }}
        >
          Back
        </a>
        <a
          href="#"
          className="button footer__button"
          onClick={(e) => {
            e.preventDefault();
            next();
          }}
        >
          Next
        </a>
      </div>
    </ModalInnerContainer>,
  ];

  function next() {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      closeModal();
    }
  }

  function previous() {
    if (step > 0) {
      setStep(step - 1);
    }
  }

  return <BaseModal>{steps[step]}</BaseModal>;
}

export function V4TransitionModal() {
  const subscription = useSudowriteStore((state) => state.subscription);
  const currentPlan = subscription.currentPlan();
  const userData = useSudowriteStore((state) => state.userData);

  if (!currentPlan) return null;
  if (subscription?.V4Transition?.hasTransitioned && !userData?.data?.v4transition?.hasSeenActivatedModal) {
    return (
      <V4TransitionModalActivated
        subscription={subscription}
        userData={userData}
      />
    );
  } else if (subscription?.V4Transition?.willTransition && !userData?.data?.v4transition?.hasSeenGeneralModal) {
    return (
      <V4TransitionModalGeneral
        subscription={subscription}
        userData={userData}
      />
    );
  } else {
    return null;
  }
}
